var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.583333,
    y: 0.583333,
    width: 40.8333,
    height: 40.8333,
    rx: 5.41667,
    stroke: "white",
    strokeOpacity: 0.15,
    strokeWidth: 1.16667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6191 24.1808C10.6191 18.4487 15.267 13.8008 20.9991 13.8008C26.7313 13.8008 31.3791 18.4487 31.3791 24.1808V31.6008C31.3791 32.0647 31.0031 32.4408 30.5391 32.4408H11.4591C10.9952 32.4408 10.6191 32.0647 10.6191 31.6008V24.1808ZM20.9991 15.4808C16.1949 15.4808 12.2991 19.3765 12.2991 24.1808V30.7608H29.6991V24.1808C29.6991 19.3765 25.8034 15.4808 20.9991 15.4808Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.56055 31.6007C9.56055 31.1368 9.93663 30.7607 10.4005 30.7607H31.6005C32.0645 30.7607 32.4405 31.1368 32.4405 31.6007C32.4405 32.0647 32.0645 32.4407 31.6005 32.4407H10.4005C9.93663 32.4407 9.56055 32.0647 9.56055 31.6007Z",
    fill: "#6F8EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0002 9.56055C21.4641 9.56055 21.8402 9.93663 21.8402 10.4005V11.4605C21.8402 11.9245 21.4641 12.3005 21.0002 12.3005C20.5362 12.3005 20.1602 11.9245 20.1602 11.4605V10.4005C20.1602 9.93663 20.5362 9.56055 21.0002 9.56055Z",
    fill: "#6F8EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9277 11.9267C12.2557 11.5987 12.7876 11.5987 13.1156 11.9267L14.1756 12.9867C14.5037 13.3147 14.5037 13.8466 14.1756 14.1746C13.8476 14.5027 13.3157 14.5027 12.9877 14.1746L11.9277 13.1146C11.5996 12.7866 11.5996 12.2547 11.9277 11.9267Z",
    fill: "#6F8EF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.074 11.9267C30.4021 12.2547 30.4021 12.7866 30.074 13.1146L29.014 14.1746C28.686 14.5027 28.1541 14.5027 27.8261 14.1746C27.4981 13.8466 27.4981 13.3147 27.8261 12.9867L28.8861 11.9267C29.2141 11.5987 29.746 11.5987 30.074 11.9267Z",
    fill: "#6F8EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.34065b7fb29703b0d92c1697484f9d75.svg";
export { ForwardRef as ReactComponent };